import React from 'react';
import { Card, CardContent } from '@lb-service/ui';
import SectionIntro from '../../../molecules/SectionIntro';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const PronunciationOutcome = () => {
  const { t } = useTranslation('common');
  return (
    <Card>
      <CardContent>
        <div id="pronunciation-course-outcome">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 mt-24">
            <SectionIntro
              title={t('service.courses.pronunciation.outcome.title')}
              intro={t('service.courses.pronunciation.outcome.intro')}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default PronunciationOutcome;
